import { render, staticRenderFns } from "./ComplaintCards.vue?vue&type=template&id=19e4b03e&"
import script from "./ComplaintCards.vue?vue&type=script&lang=js&"
export * from "./ComplaintCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports